import React from "react";
import Style from "./TransactionStatus.module.scss";
import { errorToast } from "../../../../../Utils/Toast/Toast";
import { getCheckOutApi } from "../../../../../Api/PanelAdminServices";
import { useState } from "react";
const TransactionStatus = ({ id }) => {
  const [checkout, setCheckout] = useState();
  const [createdDate, setCreatedDate] = useState();
  const [settledDate, setSettledDate] = useState();
  const [disable, setDisable] = useState(false);
  const getCheckout = async (trackId) => {
    setDisable(true);
    getCheckOutApi(trackId, (succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast("خطایی پیش آمده");
        } else {
          setCheckout(res.transaction.data);
          const deleteGlobalCreated =
            res.transaction.data.accept.created_at.split("+");
          const splitDateCreated = deleteGlobalCreated[0].split("T");
          setCreatedDate(splitDateCreated);

          const deleteGlobalSettled =
            res.transaction.data.settlement_result.settled_at.split(".");
          const splitDateSettled = deleteGlobalSettled[0].split("T");
          setSettledDate(splitDateSettled);
        }
      } else {
        errorToast("خطایی در سرور رخ داده");
      }
    });
    setDisable(false);
  };
  return (
    <>
      <button
        onClick={() => getCheckout(id)}
        className={Style.btnStyle}
        disabled={disable}
      >
        وضعیت تراکنش
      </button>
      {checkout && (
        <div className={Style.hiddenPart}>
          <h3 className={Style.items}>
            بانک:{" "}
            <span className={Style.spanPart}>
              {checkout.destination_bank.title}
            </span>
          </h3>
          <h3 className={Style.items}>
            نوع: <span className={Style.spanPart}>{checkout.description}</span>
          </h3>
          <h3 className={Style.items}>
            شماره شبا:{" "}
            <span className={Style.spanPart}>{checkout.destination_iban}</span>
          </h3>
          <h3 className={Style.items}>
            تاریخ درخواست برداشت:{" "}
            <span className={Style.spanPart}>
              {createdDate === undefined
                ? "___"
                : createdDate[1] + " / " + createdDate[0]}
            </span>
          </h3>
          <h3 className={Style.items}>
            وضعیت:{" "}
            <span className={Style.spanPart}>{checkout.status.title}</span>
          </h3>
          <h3 className={Style.items}>
            تاریخ تسویه:{" "}
            <span className={Style.spanPart}>
              {settledDate === undefined
                ? "___"
                : settledDate[1] + " / " + settledDate[0]}
            </span>
          </h3>
        </div>
      )}
    </>
  );
};

export default TransactionStatus;
